import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useAdminFetch } from '@/features/accounts/useAccounts';

// `GET` and `PUT /admin/backend-rollout`
export interface BackendRollout {
  new_users_start_on_typescript: boolean;
  updated_at: string | null;
}

// Where new users who are not staff start, Python or TypeScript. Users who
// exist keep their backend when it changes
export function useBackendRollout() {
  const adminFetch = useAdminFetch();
  return useQuery({
    queryKey: ['backend-rollout'],
    queryFn: () => adminFetch<BackendRollout>({ path: '/backend-rollout' }),
  });
}

export function useSetBackendRollout() {
  const adminFetch = useAdminFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newUsersStartOnTypeScript: boolean) =>
      adminFetch<BackendRollout>({
        path: '/backend-rollout',
        method: 'PUT',
        body: { new_users_start_on_typescript: newUsersStartOnTypeScript },
      }),
    onSuccess: (saved) => {
      queryClient.setQueryData(['backend-rollout'], saved);
    },
  });
}
